// libs.
import Vue from 'vue';
import Vuex, { Store } from 'vuex';

// state modules.
import i18n from './modules/i18n';
import form from './modules/form';
import module from './modules/module';
import settings from './modules/settings';
import hrModule from './modules/hrModule';
import userModule from './modules/user';
import tasksModule from './modules/tasks';
import dropdownModule from './modules/dropdown';
import notifications from './modules/notifications';
import attachmentsModule from './modules/attachments';
import absenceModule from './modules/absence';
import modals from './modules/modals';

let store: Store<{}> = {} as any;

export function getStore() {
  return store;
}

Vue.use(Vuex);

export default function createStore() {
  store = new Vuex.Store({
    modules: {
      i18n,
      form,
      module,
      settings,
      hrModule,
      userModule,
      tasksModule,
      notifications,
      modals,
      dropdownModule,
      attachmentsModule,
      absenceModule,
    },
    state: {},
    actions: {},
    getters: {},
    mutations: {},
  });

  return store;
}
